/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Shockwave_Therapy_TermsInputs */

const en_service_type_shockwave_therapy_terms = /** @type {(inputs: Service_Type_Shockwave_Therapy_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shockwave, heel spur, tennis elbow, achilles, tendinopathy`)
};

const pl_service_type_shockwave_therapy_terms = /** @type {(inputs: Service_Type_Shockwave_Therapy_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fala uderzeniowa, ostroga piętowa, łokieć tenisisty, ścięgno achillesa, entezopatia`)
};

/**
* | output |
* | --- |
* | "shockwave, heel spur, tennis elbow, achilles, tendinopathy" |
*
* @param {Service_Type_Shockwave_Therapy_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_shockwave_therapy_terms = /** @type {((inputs?: Service_Type_Shockwave_Therapy_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Shockwave_Therapy_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_shockwave_therapy_terms(inputs)
	return en_service_type_shockwave_therapy_terms(inputs)
});